// extracted by mini-css-extract-plugin
export default {"top":"styles_top__EC3Px","title":"styles_title__2c9sc","info":"styles_info__eF3mE"};